/**
 * These are all runtime dependencies. Any breaking changes
 * will need a migration path first!
 */
const prefix = 'urn';
const namespace = 'sfextslot';
const owner = 'permissions-pilet';
const modalNamespace = 'sfmodal';
export const permissionsPiletExtensionSlots = {
    shareButtonSlot: `${prefix}:${namespace}:${owner}:sharebutton`,
    avatarGroupSlot: `${prefix}:${namespace}:${owner}:avatargroup`,
    avatarGroupWithShareButtonSlot: `${prefix}:${namespace}:${owner}:avatargroup-with-sharebutton`,
    assignButtonSlot: `${prefix}:${namespace}:${owner}:assignbutton`,
};
export const permissionsPiletModals = {
    shareModal: `${prefix}:${modalNamespace}:${owner}:share`,
    linkBasedShareModal: `${prefix}:${modalNamespace}:${owner}:linkBasedShareModal`,
    manageUsersModal: `${prefix}:${modalNamespace}:${owner}:manageusers`,
};
export const permissionsPiletEvents = {
    shareSuccess: `${prefix}:${modalNamespace}:${owner}:share-success`,
    removeSuccess: `${prefix}:${modalNamespace}:${owner}:remove-success`,
    replaceSuccess: `${prefix}:${modalNamespace}:${owner}:replace-success`,
};
//# sourceMappingURL=extensionTypes.js.map